module.exports = __webpack_public_path__ + "static/img/14002006.90a11f9a.png";